import { render, staticRenderFns } from "./b-ticket-wrap.vue?vue&type=template&id=3a841bdc&scoped=true"
import script from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
export * from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-wrap.vue?vue&type=style&index=0&id=3a841bdc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a841bdc",
  null
  
)

export default component.exports